import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  status?: SugarmateError["status"];
  code?: SugarmateError["code"];
}

const polyglotPrefix = "toasts.forgot_password_error."

export function ForgotPasswordErrorToast(props: Props) {
  const {
    id,
    code,
    status: responseStatus,
  } = props

  const polyglot = usePolyglot()
  const body = useMemo(
    () => {
      switch (code) {
        case 1023: // turnstile error
          return polyglot.t(`${polyglotPrefix}unauthorized_body`)
        default:
          if (responseStatus === 401) { // token error
            return polyglot.t(`${polyglotPrefix}unauthorized_body`)
          }

          return polyglot.t("error_messaging.generic_error")
      }
    },
    [
      code,
      responseStatus,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}
